import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { setOnChange } from "components/special";
import { TTSModelSelector, TTSServiceSelector, TTSVoiceSelector } from "components/standart";
import { apiUrls } from "../init";
import { adminAPI } from "redux/api";

const { api } = adminAPI.actions;

const VoiceData = (props) => {
  const { getOrigins, content, setContent } = props;
  const changeContent = setOnChange(content, setContent);

  const [soundOrigins, setSoundOrigins] = useState({ models: [], voices: [] });

  useEffect(() => {
    getOrigins(
      { query: { service: content.service } },
      {
        onSuccess(body) {
          setSoundOrigins(body);
        },
      },
    );
    // на смену сервиса ищем значения для соответствующих элементов
  }, [content.service]);

  return (
    <>
      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Sounds.Voices.name" />
        </label>
        <div className="col-8">
          <input
            type="text"
            name="name"
            value={content.name || ""}
            onChange={changeContent}
            className="form-control react-form-input"
            autoComplete="off"
            required
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Sounds.Voices.voice" />
        </label>
        <div className="col-8">
          <TTSServiceSelector
            name="service"
            value={content.service}
            setValue={(service) => setContent({ ...content, ...service })}
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Sounds.Voices.voice" />
        </label>
        <div className="col-8">
          <TTSVoiceSelector
            name="voice"
            source={soundOrigins.voices}
            value={content.voice}
            setValue={(voice) => setContent({ ...content, ...voice })}
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Sounds.Voices.model" />
        </label>
        <div className="col-8">
          <TTSModelSelector
            name="model"
            source={soundOrigins.models}
            value={content.model}
            setValue={(model) => setContent({ ...content, ...model })}
          />
        </div>
      </div>
    </>
  );
};

export default connect(null, {
  getOrigins: api.get(apiUrls.origins),
})(VoiceData);
